import React from 'react';
import { FormDrawer } from './FormDrawer';

export const ContactActivitiesForm = ({
  isOpen,
  onClose,
  onSave,
  isSaving = false,
  isDarkMode = false,
  isEditing = false,
  formData,
  onChange,
  formError = '',
  zIndex = 10000,
  executiveOptions = [],
  contactOptions = [],
  funnelStageOptions = [],
  readOnly = false,
}) => {
  const actionOptions = [
    { value: '', label: 'Seleccionar acción' },
    { value: 'Llamada', label: 'Llamada' },
    { value: 'Correo', label: 'Correo' },
    { value: 'Mensaje Linkedin', label: 'Mensaje Linkedin' },
    { value: 'Mensaje WhatsApp', label: 'Mensaje WhatsApp' },
    { value: 'Solicitud LinkedIn', label: 'Solicitud LinkedIn' },
    { value: 'Envío Ficha Técnica', label: 'Envío Ficha Técnica' },
    { value: 'Envío Catálogo', label: 'Envío Catálogo' },
    { value: 'Envío Cotización', label: 'Envío Cotización' },
    { value: 'Cierre Vendida', label: 'Cierre Vendida' },
    { value: 'Cierre Perdida', label: 'Cierre Perdida' },
    { value: 'Cierre Cancelada', label: 'Cierre Cancelada' },
    { value: 'Cierre Desierta', label: 'Cierre Desierta' },
    { value: 'Agendar Visita', label: 'Agendar Visita' },
    { value: 'Visita a Terreno', label: 'Visita a Terreno' },
    { value: 'Reunión Online', label: 'Reunión Online' },
    { value: 'Reunión Presencial', label: 'Reunión Presencial' },
  ];
  const currentAction = String(formData?.action || '').trim();
  if (currentAction && !actionOptions.some((opt) => opt.value === currentAction)) {
    actionOptions.push({ value: currentAction, label: currentAction });
  }
  const nextStepOptions = [
    { value: '', label: 'Seleccionar acción' },
    ...actionOptions.filter((opt) => String(opt.value || '').trim()),
  ];
  const currentNextStep = String(formData?.next_step || '').trim();
  if (currentNextStep && !nextStepOptions.some((opt) => opt.value === currentNextStep)) {
    nextStepOptions.push({ value: currentNextStep, label: currentNextStep });
  }
  const statusOptions = [
    { value: 'Programada', label: 'Programada' },
    { value: 'Pendiente', label: 'Pendiente' },
    { value: 'Completa', label: 'Completa' },
  ];

  const selectedContactIds = Array.isArray(formData?.contact_ids)
    ? formData.contact_ids.map((id) => String(id))
    : formData?.contact_id
      ? [String(formData.contact_id)]
      : [];

  const toggleContactId = (contactId) => {
    const id = String(contactId);
    const next = selectedContactIds.includes(id)
      ? selectedContactIds.filter((value) => value !== id)
      : [...selectedContactIds, id];
    onChange('contact_ids', next);
    onChange('contact_id', next[0] || '');
  };

  const sections = [
    {
      key: 'activity',
      title: 'Datos de la actividad',
      fields: [
        { key: 'activity_date', label: 'Fecha', type: 'date' },
        {
          key: 'owner_name',
          label: 'Realizado por',
          type: 'select',
          options: executiveOptions,
        },
        { key: 'status', label: 'Estado', type: 'select', options: statusOptions },
        {
          key: 'funnel_stage',
          label: 'Etapa funnel',
          type: 'select',
          options: funnelStageOptions,
        },
        {
          key: 'contact_ids',
          label: 'Contactos',
          type: 'custom',
          fullWidth: true,
          render: ({ colors, compact }) => (
            <div>
              <div style={{ fontSize: compact ? '11px' : '12px', color: colors.text, marginBottom: '6px' }}>
                Contactos de la organización (opcional)
              </div>
              <div
                style={{
                  border: `1px solid ${colors.inputBorder}`,
                  borderRadius: '8px',
                  background: colors.inputBg,
                  padding: '8px 10px',
                  display: 'grid',
                  gap: '6px',
                  maxHeight: '160px',
                  overflowY: 'auto',
                }}
              >
                {(contactOptions || []).filter((opt) => String(opt.value || '').trim()).length === 0 ? (
                  <span style={{ fontSize: '12px', color: colors.muted }}>
                    Sin contactos en la organización. Puedes guardar la actividad igual.
                  </span>
                ) : (
                  (contactOptions || [])
                    .filter((opt) => String(opt.value || '').trim())
                    .map((opt) => {
                      const checked = selectedContactIds.includes(String(opt.value));
                      return (
                        <label
                          key={String(opt.value)}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            fontSize: '13px',
                            color: colors.inputText,
                            cursor: readOnly ? 'default' : 'pointer',
                          }}
                        >
                          <input
                            type="checkbox"
                            checked={checked}
                            disabled={readOnly}
                            onChange={() => toggleContactId(opt.value)}
                          />
                          <span>{opt.label}</span>
                        </label>
                      );
                    })
                )}
              </div>
              <p style={{ margin: '6px 0 0', fontSize: '11px', color: colors.muted }}>
                Opcional: asocia uno o más contactos, o deja vacío para actividad a nivel organización.
              </p>
            </div>
          ),
        },
      ],
    },
    {
      key: 'action_response',
      title: 'Acción realizada',
      fields: [
        {
          key: 'action',
          label: 'Acción',
          type: 'select',
          options: actionOptions,
          fullWidth: true,
        },
        {
          key: 'response_block',
          label: 'Respuesta',
          type: 'custom',
          fullWidth: true,
          render: ({ colors, compact, baseInputStyle }) => {
            const noResponse = Boolean(formData?.no_response);
            return (
              <div
                style={{
                  border: `1px solid ${colors.sectionBorder}`,
                  borderRadius: '10px',
                  background: colors.sectionBg,
                  padding: compact ? '10px' : '12px',
                  display: 'grid',
                  gap: '8px',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    gap: '10px',
                    flexWrap: 'wrap',
                  }}
                >
                  <span style={{ fontSize: compact ? '12px' : '13px', fontWeight: 600, color: colors.title }}>
                    Respuesta
                  </span>
                  <label
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '6px',
                      fontSize: '12px',
                      color: colors.text,
                      cursor: readOnly ? 'default' : 'pointer',
                      userSelect: 'none',
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={noResponse}
                      disabled={readOnly}
                      onChange={(event) => {
                        const checked = event.target.checked;
                        onChange('no_response', checked);
                        if (checked) onChange('response', '');
                      }}
                    />
                    Sin Respuesta
                  </label>
                </div>
                <textarea
                  value={formData?.response || ''}
                  disabled={readOnly || noResponse}
                  rows={4}
                  placeholder={noResponse ? 'Marcado como Sin Respuesta' : 'Describe la respuesta del contacto…'}
                  onChange={(event) => onChange('response', event.target.value)}
                  style={{
                    ...baseInputStyle,
                    marginTop: 0,
                    minHeight: '90px',
                    height: 'auto',
                    padding: '8px 10px',
                    resize: 'vertical',
                    opacity: noResponse ? 0.55 : 1,
                  }}
                />
              </div>
            );
          },
        },
      ],
    },
    {
      key: 'follow_up',
      title: 'Seguimiento',
      fields: [
        {
          key: 'has_next_steps',
          label: 'Siguientes Pasos',
          type: 'custom',
          fullWidth: true,
          render: ({ colors, compact, baseInputStyle }) => {
            const enabled = Boolean(formData?.has_next_steps);
            return (
              <div
                style={{
                  border: `1px solid ${colors.sectionBorder}`,
                  borderRadius: '10px',
                  background: colors.sectionBg,
                  padding: compact ? '10px' : '12px',
                  display: 'grid',
                  gap: '10px',
                }}
              >
                <label
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '8px',
                    fontSize: '13px',
                    fontWeight: 600,
                    color: colors.title,
                    cursor: readOnly ? 'default' : 'pointer',
                  }}
                >
                  <input
                    type="checkbox"
                    checked={enabled}
                    disabled={readOnly}
                    onChange={(event) => onChange('has_next_steps', event.target.checked)}
                  />
                  Siguientes Pasos
                </label>
                <div style={{ fontSize: '11px', color: colors.muted, lineHeight: 1.35 }}>
                  Al guardar se crea una <strong>nueva actividad Programada</strong> (no se guarda
                  como dato del seguimiento actual).
                </div>
                {enabled ? (
                  <div style={{ display: 'grid', gap: '10px' }}>
                    <label style={{ fontSize: '12px', color: colors.text }}>
                      Acción / próximo paso
                      <select
                        value={formData?.next_step || ''}
                        disabled={readOnly}
                        onChange={(event) => onChange('next_step', event.target.value)}
                        style={{ ...baseInputStyle }}
                      >
                        {nextStepOptions.map((option) => (
                          <option key={option.value || 'empty'} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </label>
                    <label style={{ fontSize: '12px', color: colors.text }}>
                      Detalle
                      <textarea
                        value={formData?.next_step_detail || ''}
                        disabled={readOnly}
                        rows={3}
                        onChange={(event) => onChange('next_step_detail', event.target.value)}
                        style={{
                          ...baseInputStyle,
                          minHeight: '70px',
                          height: 'auto',
                          padding: '8px 10px',
                          resize: 'vertical',
                        }}
                      />
                    </label>
                    <label style={{ fontSize: '12px', color: colors.text }}>
                      Fecha programada
                      <input
                        type="date"
                        value={formData?.next_step_date || ''}
                        disabled={readOnly}
                        onChange={(event) => onChange('next_step_date', event.target.value)}
                        style={{ ...baseInputStyle }}
                      />
                    </label>
                  </div>
                ) : null}
              </div>
            );
          },
        },
        {
          key: 'has_follow_up_reminder',
          label: 'Recordatorio Seguimiento',
          type: 'custom',
          fullWidth: true,
          render: ({ colors, compact, baseInputStyle }) => {
            const enabled = Boolean(formData?.has_follow_up_reminder);
            return (
              <div
                style={{
                  border: `1px solid ${colors.sectionBorder}`,
                  borderRadius: '10px',
                  background: colors.sectionBg,
                  padding: compact ? '10px' : '12px',
                  display: 'grid',
                  gap: '10px',
                }}
              >
                <label
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '8px',
                    fontSize: '13px',
                    fontWeight: 600,
                    color: colors.title,
                    cursor: readOnly ? 'default' : 'pointer',
                  }}
                >
                  <input
                    type="checkbox"
                    checked={enabled}
                    disabled={readOnly}
                    onChange={(event) => onChange('has_follow_up_reminder', event.target.checked)}
                  />
                  Recordatorio Seguimiento
                </label>
                {enabled ? (
                  <label style={{ fontSize: '12px', color: colors.text }}>
                    Fecha de recordatorio
                    <input
                      type="date"
                      value={formData?.follow_up_reminder_date || ''}
                      disabled={readOnly}
                      onChange={(event) => onChange('follow_up_reminder_date', event.target.value)}
                      style={{ ...baseInputStyle }}
                    />
                  </label>
                ) : null}
              </div>
            );
          },
        },
      ],
    },
  ];

  return (
    <FormDrawer
      isOpen={isOpen}
      onClose={onClose}
      onSave={onSave}
      isSaving={isSaving}
      isDarkMode={isDarkMode}
      title={isEditing ? 'Editar Actividad' : 'Agregar Actividad'}
      subtitle="Cualquier usuario puede registrar actividades; el responsable del prospecto vive en la organización"
      sections={sections}
      formData={formData}
      onChange={onChange}
      formError={formError}
      width={560}
      zIndex={zIndex}
      readOnly={readOnly}
    />
  );
};

export default ContactActivitiesForm;
